import { FeedbackWrapper } from 'components/FeedbackWrapper';
import DefaultLayout from 'layouts/defaultLayout';

const QuoteFailed = () => (
  <DefaultLayout renderStepper={false} verticalCentered extendContainer>
    <FeedbackWrapper
      feedback="declined"
      title="We are having issues creating your quote."
      subtitle="We will contact you when it will be resolved."
    />
  </DefaultLayout>
);

export default QuoteFailed;
